import { render } from "./ByNeed.vue?vue&type=template&id=1edfb838"
import script from "./ByNeed.vue?vue&type=script&lang=js"
export * from "./ByNeed.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__